import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
	root: {
		flexGrow: 1,
		margin: '20px 20px',
	},
	gridContainer:{
		width: '100%',
	},
	contenedor: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		margin: '0px 38px 10px 38px',
	},
	contenedorCard: {
		margin: '0px 10px',
		textAlign: 'center',
	},
	cardContent: {
		padding: '5px',
		// height: '90px',
		width: '150px',
	},
	iconGeneradas: {
		color: 'green',
	},
	iconPendientes: {
		color: 'red',
	},
	typographyTitulo: {
		fontSize: '15px',
		fontWeight: 'bold',
	},
	typographyTotales: {
		fontSize: '30px',
		fontWeight: 'bold',
	},
	avatar:{
		backgroundColor: 'white',
		color: 'black',
		height: '100%',
	},		
	paper: {
		padding: theme.spacing(2),
		textAlign: 'center',
		color: theme.palette.text.secondary,
		// height:'17vh',
	},	
	description: {
		color: 'black',
        fontWeight: 'bold',
	},
	success: {
		backgroundColor: 'green',
		color: 'white',
		borderColor: 'green',
        marginRight: '20px',
	},
	error: {
		backgroundColor: '#d93838',
		color: 'white',
		borderColor: 'red',
	},
    textoAlinear: {
        textAlign: 'center'
    },
	iconSuccess: {
		color: 'green',
		fontSize: '60px',
	},
}))